<template>
  <a-layout>
    <a-layout-header>
      <Header :is-login="true" />
    </a-layout-header>
    <a-layout-content style="min-height: 100vh">
      <div class="maintain-wrapper">
        <img src="@G/assets/suprise.svg" />
        <h1>系统维护中</h1>
        <img src="@G/assets/maintain_guy.svg" />
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
import Header from '@GC/Header'

export default {
  name: 'Maintain',
  components: { Header },
  async created() {
    // 隨便打隻api，如果已經不是維護中，則導回登入頁
    try {
      const appName = process.env.VUE_APP_FOLDER_NAME
      let switchName = ''
      let apiProvider = ''
      if (appName === 'XNB_XO') {
        apiProvider = this.$operatorGraphqlProvider
        switchName = 'system_maintenance_operator_switch'
      } else {
        apiProvider = this.$departmentGraphqlProvider
        switchName = 'system_maintenance_fenko_switch'
      }
      const { allSettings } = await apiProvider.getSystemInfo()

      if (allSettings[switchName] === '2') {
        this.$router.push('/')
      }
    } catch (error) {
      console.error('[ERROR] Maintain page API error: ', error)
    }
  }
}
</script>

<style lang="scss" scoped>
.maintain-wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  min-height: calc(100vh - 60px);
  h1 {
    margin: 35px 0 50px 0;
    color: #3a3a3a;
    font-size: 28px;
  }
}
</style>
